import React from 'react'
import "./aboutContent.css"
import { Link } from 'react-router-dom'
import pro1 from "../Assets/me.jpg"
function AboutContent() {
    return (
        <div className='about'>
            <div className='left'>
                <h1>Who Am I ?</h1>
                <p>I am a Junior Cyber Security Consultant. My aim is to be hired for a professional role where I can help the company to
                    successfully fulfill its vision while continuing to improve my skills.</p>
                <Link to="/contact">
                    <button className='btn'>Contact</button>
                </Link>
                <p>I am a Cyber Security Consultant with a strong foundation in software development and application security.

                    After graduating from Yildiz Technical University with a degree in Civil Engineering in 2023, I transitioned into tech through hands-on software development training at Patika. There, I gained practical experience in JavaScript, TypeScript, React, and modern front-end technologies. I then co-founded Hypance, where I worked on real-world, React-based applications, strengthening my problem-solving and collaboration skills in the process.

                    Currently, I specialise in application and API security, contributing to vulnerability analysis, security testing and improving detection workflows, while also participating in customer network assessments and promoting secure development practices.

                    I am driven by continuous learning and impact-oriented work, and I aim to build scalable and secure systems in collaborative environments.

                    Let’s connect.</p>
                <p>Regards.</p>
            </div>
            <div className='right'>
                <div className='img-container'>
                    <div className='img-stack top'>
                        <img className='img' src={pro1} alt='me' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutContent